import './style.css'
import * as THREE from 'three'
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import sources from './sources'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

/*
 * Sources
 */
const fontLoader = new THREE.FontLoader();
let fonts = []
for (const source of sources) {
    if (source.type === 'font') {
        fontLoader.load(source.path, (font) => {
            fonts.push(font)
            sourceLoaded()
        })
    }
}

const toLoad = sources.length
let loaded = 0;
const sourceLoaded = () => {
    loaded++;
    if (loaded === toLoad) {
        init();
        
    }
}

const init = () => {
    /**
     * Base
     */
    // Canvas
    const canvas = document.querySelector('canvas.webgl')

    // Scene
    const scene = new THREE.Scene()

    /**
     * Sizes
     */
    const sizes = {
        width: window.innerWidth,
        height: window.innerHeight
    }

    window.addEventListener('resize', () =>
    {
        // Update sizes
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight

        // Update camera
        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()

        // Update renderer
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    })

    /**
     * Lights
     */
    const light = new THREE.AmbientLight( 0x404040 ); // soft white light
    scene.add( light ); 
    const directionalLight = new THREE.DirectionalLight( 0xffffff, 1.00 );
    directionalLight.position.set(1,1,1)
    scene.add( directionalLight );

    /**
     * Camera
     */
    // Base camera
    const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
    camera.position.x = 1
    camera.position.y = 1
    camera.position.z = 2
    scene.add(camera)

    // Controls
    const controls = new OrbitControls(camera, canvas)
    controls.enableDamping = true
    controls.enableZoom = false
    controls.enablePan = false

    /**
     * Torus
     */
    const groupTorus = new THREE.Group();
    let numTorus = 10;
    const geometry = new THREE.TorusGeometry( 0.5, 0.001, 3, 200 );
    const material = new THREE.MeshStandardMaterial({
        color: 0x404040
    });

    let alltorus = []
    let torus

    for (let i = 0; i < numTorus; i++) {
        torus = new THREE.Mesh( geometry, material );
        alltorus.push(torus);
        torus.rotation.x = 180 / numTorus * i * Math.PI / 180;
        groupTorus.add(torus);
    }
    scene.add( groupTorus );
    

    /**
     * LINE
     */
    const materialLine = new THREE.LineBasicMaterial({
        color: 0x000000
    });

    const positions = [];
    positions.push( new THREE.Vector3( -1.5, 0, 0 ) );
    positions.push( new THREE.Vector3( 1.5, 0, 0 ) );
    const geometryline = new THREE.BufferGeometry().setFromPoints( positions );
    const line = new THREE.Line( geometryline, materialLine );
    line.scale.x = 0.0;
    scene.add( line );

    /**
     * TEXT
     */
    let xOffset = -0.15
    // BIXD - Offering
    let geometryText1 = new THREE.TextGeometry("OFFERING", {
        font: fonts[0],
        size: 0.05,
        height: 0.01,
    });
    let bixdText1 = new THREE.Mesh(geometryText1, [
        new THREE.MeshPhongMaterial({color: 0x000000}),
        new THREE.MeshPhongMaterial({color: 0x999999})
    ]);
    bixdText1.scale.set(0, 0, 0)
    bixdText1.position.set(-0.5 + xOffset, -0.5, 0)


    // BIXD - Meaning
    let geometryText2 = new THREE.TextGeometry("MEANING", {
        font: fonts[0],
        size: 0.05,
        height: 0.01
    });
    let bixdText2 = new THREE.Mesh(geometryText2, [
        new THREE.MeshPhongMaterial({color: 0x000000}),
        new THREE.MeshPhongMaterial({color: 0x999999})
    ]);
    bixdText2.scale.set(0, 0, 0)
    bixdText2.position.set(0 + xOffset, 0, 0)

    // BIXD - Behaviour
    let geometryText3 = new THREE.TextGeometry("BEHAVIOUR", {
        font: fonts[0],
        size: 0.05,
        height: 0.01
    });
    let bixdText3 = new THREE.Mesh(geometryText3, [
        new THREE.MeshPhongMaterial({color: 0x000000}),
        new THREE.MeshPhongMaterial({color: 0x999999})
    ]);
    bixdText3.scale.set(0, 0, 0)
    bixdText3.position.set(-0.5 + xOffset, 0.5, 0)

    // BIXD - Image
    let geometryText4 = new THREE.TextGeometry("IMAGE", {
        font: fonts[0],
        size: 0.05,
        height: 0.01
    });
    let bixdText4 = new THREE.Mesh(geometryText4, [
        new THREE.MeshPhongMaterial({color: 0x000000}),
        new THREE.MeshPhongMaterial({color: 0x999999})
    ]);
    bixdText4.scale.set(0, 0, 0)
    bixdText4.position.set(0.5 + xOffset, 0.5, 0)

    // BIXD - Image
    let geometryText5 = new THREE.TextGeometry("STORY", {
        font: fonts[0],
        size: 0.05,
        height: 0.01
    });
    let bixdText5 = new THREE.Mesh(geometryText5, [
        new THREE.MeshPhongMaterial({color: 0x000000}),
        new THREE.MeshPhongMaterial({color: 0x999999})
    ]);
    bixdText5.scale.set(0, 0, 0)
    bixdText5.position.set(0.5 + xOffset, -0.5, 0)
    
    
    scene.add(bixdText1)
    scene.add(bixdText2)
    scene.add(bixdText3)
    scene.add(bixdText4)
    scene.add(bixdText5)


    /**
     * Renderer
     */
    const renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true
    })
    renderer.setSize(sizes.width, sizes.height)
    renderer.setClearColor(0xFCFE8A, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    /**
     * Animate
     */
    const clock = new THREE.Clock()
    let lastElapsedTime = 0


    const tick = () =>
    {
        const elapsedTime = clock.getElapsedTime()
        const deltaTime = elapsedTime - lastElapsedTime
        lastElapsedTime = elapsedTime

        geometryline.attributes.position.needsUpdate = true

        if (state == "idle") {
            for (let i = 0; i < numTorus; i++) {
                alltorus[i].rotation.x = 4. * Math.sin(180 / numTorus * i * elapsedTime / 10. * Math.PI / 180);
            }
        }

        // Update controls
        controls.update()

        // Render
        renderer.render(scene, camera)

        // Call tick again on the next frame
        window.requestAnimationFrame(tick)
    }

    const StateManager = (_state) => {
        let d;
        state = _state;
        switch (_state) {
            case "idle":
                d = 1;

                // Camera
                gsap.to( camera.position, {
                    duration: 1,
                    x: 1,
                    y: 1,
                    z: 2,
                    onUpdate: function() {
                        camera.lookAt( new THREE.Vector3(0, 0, 0) );
                    }
                } );

                // Position
                gsap.to(alltorus[0].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[1].position, { duration: d, x: 0.0, y: 0.0, z: 0.0  });

                gsap.to(alltorus[2].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[3].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                
                gsap.to(alltorus[4].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[5].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                
                gsap.to(alltorus[6].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[7].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                
                gsap.to(alltorus[8].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[9].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                // Rotation
                gsap.to(alltorus[0].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[1].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[2].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[3].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[4].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[5].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[6].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[7].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[8].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[9].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                // LINE
                gsap.to(line.scale, { duration: d, x: 0});

                // Text
                bixdText1.scale.set(0, 0, 0)
                bixdText2.scale.set(0, 0, 0)
                bixdText3.scale.set(0, 0, 0)
                bixdText4.scale.set(0, 0, 0)
                bixdText5.scale.set(0, 0, 0)
                break;
            case "bixd":
                d = 1;

                // Camera
                gsap.to( camera.position, {
                    duration: 1,
                    x: 1,
                    y: 1,
                    z: 2,
                    onUpdate: function() {
                        camera.lookAt( new THREE.Vector3(0, 0, 0) );
                    }
                } );

                // Position
                gsap.to(alltorus[0].position, { duration: d, x: -1, y: 0.0, z: 0.0 });
                gsap.to(alltorus[1].position, { duration: d, x: -1, y: 0.0, z: 0.0  });

                gsap.to(alltorus[2].position, { duration: d, x: -0.5, y: 0.0, z: 0.0 });
                gsap.to(alltorus[3].position, { duration: d, x: -0.5, y: 0.0, z: 0.0 });
                
                gsap.to(alltorus[4].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[5].position, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                
                gsap.to(alltorus[6].position, { duration: d, x: 0.5, y: 0.0, z: 0.0 });
                gsap.to(alltorus[7].position, { duration: d, x: 0.5, y: 0.0, z: 0.0 });
                
                gsap.to(alltorus[8].position, { duration: d, x: 1, y: 0.0, z: 0.0 });
                gsap.to(alltorus[9].position, { duration: d, x: 1, y: 0.0, z: 0.0 });


                // Rotation
                gsap.to(alltorus[0].rotation, { duration: d, x: -3.5, y: 0.5, z: 0.0 });
                gsap.to(alltorus[1].rotation, { duration: d, x: -3.5, y: 0.5, z: 0.0 });

                gsap.to(alltorus[2].rotation, { duration: d, x: 1.3, y: 0.0, z: 0.0 });
                gsap.to(alltorus[3].rotation, { duration: d, x: 1.3, y: 0.0, z: 0.0 });

                gsap.to(alltorus[4].rotation, { duration: d, x: 1.6, y: -0.6, z: 0.0 });
                gsap.to(alltorus[5].rotation, { duration: d, x: 1.6, y: -0.6, z: 0.0 });

                gsap.to(alltorus[6].rotation, { duration: d, x: 1.5, y: -0.9, z: 0.0 });
                gsap.to(alltorus[7].rotation, { duration: d, x: 1.5, y: -0.9, z: 0.0 });

                gsap.to(alltorus[8].rotation, { duration: d, x: -0.3, y: 0.8, z: 0.0 });
                gsap.to(alltorus[9].rotation, { duration: d, x: -0.3, y: 0.8, z: 0.0 });


                // LINE
                gsap.to(line.scale, { duration: d, x: 1.0});

                // Text
                bixdText1.scale.set(0, 0, 0)
                bixdText2.scale.set(0, 0, 0)
                bixdText3.scale.set(0, 0, 0)
                bixdText4.scale.set(0, 0, 0)
                bixdText5.scale.set(0, 0, 0)

                break;        
            case "bios":
                d = 1;

                // Camera
                gsap.to( camera.position, {
                    duration: 1,
                    x: 0,
                    y: 0,
                    z: 3,
                    onUpdate: function() {
                        camera.lookAt( new THREE.Vector3(0, 0, 0) );
                    }
                } );

                // Position
                gsap.to(alltorus[0].position, { duration: d, x: -0.5, y: -0.5, z: 0 });
                gsap.to(alltorus[1].position, { duration: d, x: -0.5, y: -0.5, z: 0  });

                gsap.to(alltorus[2].position, { duration: d, x: 0.5, y: -0.5, z: 0 });
                gsap.to(alltorus[3].position, { duration: d, x: 0.5, y: -0.5, z: 0 });
                
                gsap.to(alltorus[4].position, { duration: d, x: 0, y: 0, z: 0 });
                gsap.to(alltorus[5].position, { duration: d, x: 0, y: 0, z: 0 });
                
                gsap.to(alltorus[6].position, { duration: d, x: 0.5, y: 0.5, z: 0 });
                gsap.to(alltorus[7].position, { duration: d, x: 0.5, y: 0.5, z: 0 });
                
                gsap.to(alltorus[8].position, { duration: d, x: -0.5, y: 0.5, z: 0 });
                gsap.to(alltorus[9].position, { duration: d, x: -0.5, y: 0.5, z: 0 });


                // Rotation
                gsap.to(alltorus[0].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[1].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[2].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[3].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[4].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[5].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[6].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[7].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                gsap.to(alltorus[8].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });
                gsap.to(alltorus[9].rotation, { duration: d, x: 0.0, y: 0.0, z: 0.0 });

                // LINE
                gsap.to(line.scale, { duration: d, x: 0});

                // Text
                gsap.to(bixdText1.scale, {duration: d, x: 1, y: 1, z: 1});
                gsap.to(bixdText2.scale, {duration: d, x: 1, y: 1, z: 1});
                gsap.to(bixdText3.scale, {duration: d, x: 1, y: 1, z: 1});
                gsap.to(bixdText4.scale, {duration: d, x: 1, y: 1, z: 1});
                gsap.to(bixdText5.scale, {duration: d, x: 1, y: 1, z: 1});
                break;
            default:
                console.log("default");
        }
    }

    let state;
    StateManager("bixd");
    tick()
    
    /**
     * BUTTONS
     */
    document.getElementById("idle").addEventListener("click", () => {
        StateManager("idle");
    })
    document.getElementById("bixd").addEventListener("click", () => {
        StateManager("bixd");
    })
    document.getElementById("bios").addEventListener("click", () => {
        StateManager("bios");
    })


    /**
     * SCROLL
     */
     const setScrollTrigger = () => {
        gsap.registerPlugin(ScrollTrigger);
    
        let section = 0;
        const desktopAnimation = () => {
            console.log("Desktop animation")
            let tl = gsap.timeline({
                default: {
                    duration: 1,
                    ease: "power2.inOut",
                },
                scrollTrigger: {
                    trigger: "#container",
                    start: "top top",
                    end: "bottom bottom",
                    scrub: 0.5,
                },
            });
            

            tl.to(".webgl", {
                scale: 0.5,
                left: "calc(50% - 100px)",
                top: "calc(-50% + 100px)",
                onUpdate: () => {
                    StateManager("idle")
                },
                onStart: () => {
                    document.getElementsByClassName("webgl")[0].style.zIndex = 1;
                  },
                  onReverseComplete: () => {
                    document.getElementsByClassName("webgl")[0].style.zIndex = 0;
                    StateManager("bixd")
                  },
            }, section);
            section++;
        }
    
    
        ScrollTrigger.matchMedia({
            "(prefers-reduced-motion: no-preference)": desktopAnimation,
        });
    }
    setScrollTrigger();
}